import axios from 'axios'


export function request(config) {
    // 1.创建axios的实例
    const instance = axios.create({
        // baseURL: 'http://39.98.118.21:8102/jeecg-boot',
        // baseURL: 'http://192.168.10.134:8102/jeecg-boot',
        // baseURL: 'http://192.168.10.132:8102/jeecg-boot',
        baseURL: 'http://121.28.81.118:8102/jeecg-boot',
        // baseURL: 'https://2l916746t7.goho.co/jeecg-boot',
        // timeout: 6000
    })

    // 2.axios的拦截器
    // 2.1.请求拦截的作用
    instance.interceptors.request.use(config => {
        return config
    }, err => {
        // console.log(err);
    })

    // 2.2.响应拦截
    instance.interceptors.response.use(res => {
        return res.data

    }, err => {
        return Promise.reject(err); // reject这个错误信息
    })

    // 3.发送真正的网络请求
    return instance(config)
}